import { Button } from "@mui/material";
import Logo from "../assets/logo.png";
import { styled } from "@mui/material/styles";
import { Link } from "preact-router";

const Container = styled("div")`
  height: 100vh;
  color: #fff;
  width: 100%;
  background: black;
  text-align: center;
  .homeImage {
    width: 100%;
    height: 65%;
  }
  .logo {
    width: 250px;
    height: auto;
    margin-top: 20px;
  }
  .contentWrapperr {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 90%;
  }
  .headerText {
    color: #f7f7f7;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
  }
  .subText {
    color: #f7f7f7;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    margin: 20px 0;
  }
  .artistLoginButton {
    width: 200px;
    text-transform: none;
    line-height: 60px;
    margin-top: 30px;
    height: 60px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    outline: none;
    font-family: Poppins;
    text-decoration: none;
  }
  .artistLoginButton:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
`;

function VerificationError() {
  return (
    <Container>
      <img src={Logo} alt="Dhun Jam" className="logo" />
      <div className="contentWrapperr">
        <div className="headerText">Please sign in again to continue.</div>
        <Link href={"/"} className="artistLoginButton">
          Admin Login
        </Link>
      </div>
    </Container>
  );
}

export default VerificationError;
